import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function DefaultButton({ text, link, buttonClass }) {
  const [activeButton, setActiveButton] = useState(null);
  const navigate = useNavigate();

  const handleButtonClick = () => {
    setActiveButton(link);

    const isSmallDevice = window.matchMedia('(max-width: 768px)').matches;
    const timeout = isSmallDevice ? 450 : 0;

    setTimeout(() => {
      // Redirect to the link after the animation
      if (link.startsWith('http')) {
        // window.location.href = link; 
        window.open(link, '_blank') // For external links
      } else {
        navigate(link); // For internal navigation
      }
    }, timeout);
  };

  return (
    <button 
      className={`progress-button-mcare px-8 py-2 uppercase font-semibold tracking-wider text-center transition duration-300 ease-in-out w-full lg:w-1/2 ${buttonClass}`}
      onClick={handleButtonClick}>
      {text}
    </button>
  );
}

export default DefaultButton;
